import React, { useState, useEffect, useRef } from "react";
import "../css/TrainingCard.css";
import lastImg from "../assets/trainingbottom1.png";
import firstImg from "../assets/trainingtop1.png";
import topInner from "../assets/trainingtop1.png";
import bottomInner from "../assets/trainingbottom1.png";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { LuDownload } from "react-icons/lu";
import { IoMdAdd } from "react-icons/io";
import { motion, AnimatePresence } from "framer-motion";
import { gsap } from "gsap";

const TrainingCard = ({
  title,
  points = [],
  subscribedPrice,
  unsubscribedPrice,
  isEditable = false,
  onClose,
  onSave,
  onAddService,
  onDelete,
  onDeleteService,
}) => {
  // Local states for edit mode:
  const [services, setServices] = useState(points);
  const [showInput, setShowInput] = useState(false);
  const [newPoint, setNewPoint] = useState("");

  const [isEditingSubscribed, setIsEditingSubscribed] = useState(false);
  const [isEditingUnsubscribed, setIsEditingUnsubscribed] = useState(false);
  const [editedSubscribedPrice, setEditedSubscribedPrice] = useState(subscribedPrice);
  const [editedUnsubscribedPrice, setEditedUnsubscribedPrice] = useState(unsubscribedPrice);

  const cardRef = useRef(null);

  // Animate card entrance
  useEffect(() => {
    if (cardRef.current) {
      gsap.fromTo(
        cardRef.current,
        { opacity: 0, scale: 0.9, y: 20 },
        { opacity: 1, scale: 1, y: 0, duration: 0.6, ease: "power3.out" }
      );
    }
  }, []);
  const formatPrice = (value) => {
    const number = Number(value) || 0;
    return number.toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };
  useEffect(() => {
    setServices(points);
    setEditedSubscribedPrice(subscribedPrice);
    setEditedUnsubscribedPrice(unsubscribedPrice);
  }, [points, subscribedPrice, unsubscribedPrice]);

  const handleServiceDelete = (index) => {
    const updatedServices = services.filter((_, i) => i !== index);
    setServices(updatedServices);
    if (onDeleteService) onDeleteService(index);
  };

  const handleAddServiceClick = () => {
    if (newPoint.trim() === "") return;
    const updatedServices = [...services, newPoint.trim()];
    setServices(updatedServices);
    if (onAddService) onAddService(newPoint);
    setNewPoint("");
    setShowInput(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleAddServiceClick();
  };

  const handlePriceKeyDown = (e, type) => {
    if (e.key === "Enter") {
      if (type === "subscribed") setIsEditingSubscribed(false);
      if (type === "unsubscribed") setIsEditingUnsubscribed(false);
    }
  };

  const handleSaveClick = () => {
    if (onSave) onSave(services, editedSubscribedPrice, editedUnsubscribedPrice);
  };

  return (
    <motion.div
      ref={cardRef}
      className={`training-package-card-wrapper ${isEditable ? "editable-modal" : ""}`}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4 }}
    >
      <div className={`training-package-card ${isEditable ? "training-modal-card" : ""}`}>
        {/* Top Image */}
        <motion.div
          className={`training-card-top-image1${isEditable ? "-edit" : ""}`}
          initial={{ y: -15, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <img src={firstImg} alt="top decoration" />
        </motion.div>

        <motion.div
          className="training-title"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.2 }}
        >
          {title}
        </motion.div>

        <div className="training-package-card-body">
          <div className="card-total-body">
            <div className="training-interbox">
              <div className="training-card-top-image-inner">
                <img src={topInner} alt="top decoration" />
              </div>

              {isEditable ? (
                <div className="training-card-edit-pricing">
                  <p>Subscribed User Price</p>
                  <h4 className="training-edit-sub-price">
                    {isEditingSubscribed ? (
                      <motion.input
                        type="number"
                        value={editedSubscribedPrice}
                        onChange={(e) => setEditedSubscribedPrice(e.target.value)}
                        onKeyDown={(e) => handlePriceKeyDown(e, "subscribed")}
                        autoFocus
                        className="price-input"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                      />
                    ) : (
                      <motion.span
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                   ₹{formatPrice(editedSubscribedPrice)}
                        <motion.button
                          className="training-price-edit-btn"
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.9 }}
                          onClick={() => setIsEditingSubscribed(true)}
                        >
                          <FiEdit size={18} color="#000" />
                        </motion.button>
                      </motion.span>
                    )}
                  </h4>

                  <p>Unsubscribed User Price</p>
                  <h4 className="training-edit-sub-price">
                    {isEditingUnsubscribed ? (
                      <motion.input
                        type="number"
                        value={editedUnsubscribedPrice}
                        onChange={(e) => setEditedUnsubscribedPrice(e.target.value)}
                        onKeyDown={(e) => handlePriceKeyDown(e, "unsubscribed")}
                        autoFocus
                        className="price-input"
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                      />
                    ) : (
                      <motion.span
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                 ₹{formatPrice(editedUnsubscribedPrice)}
                        <motion.button
                          className="training-price-edit-btn"
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.9 }}
                          onClick={() => setIsEditingUnsubscribed(true)}
                        >
                          <FiEdit size={18} color="#000" />
                        </motion.button>
                      </motion.span>
                    )}
                  </h4>
                </div>
              ) : (
                <div className="training-card-pricing">
                  <p>
                    <strong className="add-package-training-text1">Subscribed User Price</strong>
                    <br />
                    <span className="training-price-subscribed">₹{formatPrice(subscribedPrice)}</span>
                  </p>
                  <p>
                    <strong className="add-package-training-text1">Unsubscribed User Price</strong>
                    <br />
                    <span className="training-price-unsubscribed"> ₹{formatPrice(unsubscribedPrice)}</span>
                  </p>
                </div>
              )}

              <div className="training-card-bottom-image-inner">
                <img src={bottomInner} alt="bottom decoration" />
              </div>
            </div>

            <div
              className={`training-interbox1 ${isEditable ? "training-points-underscore" : ""}`}
            >
              <ul className={isEditable ? "custom-list" : "training-points-list"}>
                <AnimatePresence>
                  {services.map((point, index) => (
                    <motion.li
                      key={index}
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: 20 }}
                      transition={{ duration: 0.3 }}
                      className={isEditable ? "custom-list-item" : ""}
                    >
                      {isEditable ? (
                        <>
                          <motion.span
                            className="delete-icon"
                            onClick={() => handleServiceDelete(index)}
                            whileHover={{ scale: 1.2, color: "#FF3D00" }}
                            whileTap={{ scale: 0.9 }}
                          >
                            −
                          </motion.span>{" "}
                          {point}
                        </>
                      ) : (
                        point
                      )}
                    </motion.li>
                  ))}
                </AnimatePresence>

                {showInput && (
                  <motion.li
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0 }}
                  >
                    <input
                      type="text"
                      className="price-input"
                      value={newPoint}
                      onChange={(e) => setNewPoint(e.target.value)}
                      onKeyDown={handleKeyPress}
                      autoFocus
                    />
                  </motion.li>
                )}
              </ul>
            </div>
          </div>
        </div>

        {isEditable ? (
          <>
            <div className="edit-btns">
              <motion.button
                className="training-add-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setShowInput(true)}
              >
                <IoMdAdd className="add-package-icon" color="#EBA8BF" /> Add
              </motion.button>

              <motion.button
                className="training-save-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleSaveClick}
              >
                <LuDownload className="add-package-icon" color="#EBA8BF" /> Save
              </motion.button>
            </div>

            <motion.span
              className="close-btn"
              onClick={onClose}
              whileHover={{ scale: 1.1, color: "#FF3D00" }}
            >
              Close
            </motion.span>
          </>
        ) : (
          <div className="training-card-actions">
            <motion.button
              className="add-package-training-edit-button"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              onClick={onAddService}
            >
              <FiEdit size={20} color="#000" />
              <span className="add-packages-save-text">Edit</span>
            </motion.button>

            <motion.button
              className="add-package-training-delete-button"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              onClick={onDelete}
            >
              <RiDeleteBin6Fill size={32} color="#FF3D00" />
            </motion.button>
          </div>
        )}

        <motion.div
          className="training-card-bottom-image"
          initial={{ y: 15, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <img src={lastImg} alt="bottom decoration" />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default TrainingCard;
